export default {
    table: {
        name: "Անուն",
        code: "Կոդ",
        phone: "Հեռախոս",
        email: "Էլ. փոստ",
        first_name: "Անուն",
        last_name: "Ազգանուն",
        mobile_number: "Բջջային համար",
        city: "Քաղաք",
        country: "Երկիր",
        address: "Հասցե",
        mobile: "Բջջային",
        state: "Մարզ/Նահանգ",
        country_code: "Երկրի կոդ",
        company_code: "Ընկերության կոդ",
        company_name: "Ընկերության անուն",
        app_id: "Հավելվածի ID",
        city_zone: "Քաղաքային գոտի",
        area_code: "Տարածքի կոդ",
        time_zone: "Ժամային գոտի",
    },

    table_product: {
        product_name: "Ապրանքի անուն",
    },

    table_approval: {
        title: "Հաստատման գործընթացի սխեմա",
        add: "Ավելացնել հաստատման գործընթացի սխեմա",
        edit: "Խմբագրել հաստատման գործընթացի սխեման",
        person: "Հաստատող անձ",
        create_time: "Ստեղծման ժամանակ",
        note: "Նշում՝",
    },
};